import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bButlerService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-butler-service'
import { FloatingActionButton } from '@pets-ui/FloatingActionButton/FloatingActionButton'
import { Lottie } from '@pets-ui/Lottie/Lottie'
import { SvgIcon } from '@pets-ui/SvgIcon/SvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import { Tooltip } from '@pets-ui/Tooltip/Tooltip'
import * as stylex from '@stylexjs/stylex'
import { useHistory } from 'react-router-dom-v5'
import { getButlerEntryPath, getButlerRecommendationsPath } from '../../../../fp-b2b-shared/ai-purchase-order/constants'
import LoadingIconData from './assets/loading-icon.json'
import Star from './assets/star.svg?react'

const styles = stylex.create({
  floatingButton: {
    backgroundImage: 'linear-gradient(136deg, #AFD8FF 16.72%, #06F 53.7%, #CA73FF 84.32%)',
    height: 56,
    width: 56,
  },
  loadingIcon: {
    height: 56,
    width: 56,
  },
  // drawer 必須蓋在 tooltip 之上
  tooltipZIndex: {
    zIndex: zIndex.appBar,
  },
})

export interface FloatingButlerProps {
  campaignId: number
  /** 平台路由前綴，例如 /merchant/dcs001 */
  basePath: string
}

const getTooltipText = ({
  isGetOrderStatusFailed,
  isOrderStatusIncorrectFormat,
  isOrderStatusInProgress,
  isOrderStatusCompleted,
  isImported,
}: {
  isGetOrderStatusFailed: boolean
  isOrderStatusIncorrectFormat: boolean
  isOrderStatusInProgress: boolean
  isOrderStatusCompleted: boolean
  isImported: boolean
}) => {
  if (isGetOrderStatusFailed || isOrderStatusIncorrectFormat) {
    return '發生未知的錯誤'
  }
  if (!isOrderStatusInProgress && !isOrderStatusCompleted) {
    return '快速下單，幫你快速完成採購工作'
  }
  if (isOrderStatusInProgress) {
    return 'AI 辨識中...'
  }
  if (isOrderStatusCompleted && !isImported) {
    return 'AI 辨識完成'
  }
  if (isImported) {
    return '已匯入 AI 購物車'
  }
  return undefined
}

export const FloatingButler = ({ campaignId, basePath }: FloatingButlerProps) => {
  const { isGetOrderStatusFailed, isOrderStatusIncorrectFormat, isImported, isOrderStatusInProgress, isOrderStatusCompleted } = useFpB2bButlerService(campaignId, Platform.MERCHANT)
  const history = useHistory()

  const handleClick = () => {
    history.push(isOrderStatusCompleted
      ? getButlerRecommendationsPath(basePath, Platform.MERCHANT)
      : getButlerEntryPath(basePath, Platform.MERCHANT))
  }

  return (
    <Tooltip
      rootStyle={styles.tooltipZIndex}
      title={(
        <Text variant="caption">
          {getTooltipText({
            isGetOrderStatusFailed,
            isOrderStatusIncorrectFormat,
            isOrderStatusInProgress,
            isOrderStatusCompleted,
            isImported,
          })}
        </Text>
      )}
      placement="left"
      offset={[0, 16]}
      strategy="fixed"
    >
      <FloatingActionButton rootStyle={styles.floatingButton} onClick={handleClick}>
        {isOrderStatusInProgress
          ? <Lottie animationDataProps={LoadingIconData} rootStyle={styles.loadingIcon} />
          : (
            <SvgIcon fontSize={24}>
              <Star />
            </SvgIcon>
          )}
      </FloatingActionButton>
    </Tooltip>
  )
}
